/** Add more if needed */
export const ENTITY_REQUIREMENT_TYPES = {
  PROJECT_MEMBERSHIP: 'ProjectMembership'
};
